import { useEffect, useState } from '@bpmn-io/properties-panel/preact/hooks';
import type { FetchState } from '../../../types/properties-panel';
import type { ActiveProcesses } from '../../../types/sharepoint';
import { useMountRef } from './useMountRef';
import { useService } from './useService';

export const useFetchActiveProcesses = ({
    enabled = true,
    siteUrl,
    definitionKey,
}: {
    enabled?: boolean;
    siteUrl?: string;
    definitionKey?: string;
}): FetchState<ActiveProcesses[]> => {
    const mountRef = useMountRef();
    const eventBus = useService('eventBus');

    const [state, setState] = useState<FetchState<ActiveProcesses[]>>({
        data: undefined,
        loading: false,
        error: undefined,
    });

    // Listen for fetch result
    useEffect(() => {
        const handler = (_event: any, payload: FetchState<ActiveProcesses[]>) => {
            if (!mountRef.current) return;

            setState(payload);
        };

        eventBus.on('activeProcessesFetched', handler);

        return () => {
            eventBus.off('activeProcessesFetched', handler);
        };
    }, [eventBus]);

    // Trigger fetch
    useEffect(() => {
        if (!enabled || !siteUrl || !definitionKey) return;
        eventBus.fire('fetchActiveProcesses', siteUrl, definitionKey);

        setState({
            data: undefined,
            loading: true,
            error: undefined,
        });

        eventBus.fire('fetchActiveProcesses', siteUrl, definitionKey);
    }, [enabled, siteUrl, definitionKey, eventBus]);

    return state;
};
